import { parseObjectFromApi } from "@/views/va-orderTest/merch/helpers/dataFomatter.js"
import { getAllMerchandisesForOrder } from "@/api/markup";
import _, { truncate } from "lodash";

const merchandise = {
  namespaced: true,
  state: {
    merchList: [], // used for store merch from api
    selectedMerchMap: {}, // used for store merch selected by user
    editOrderMerchList: [], // store the merch in edit order ordered items
    editOrderDate: "", // edit order created date, see if merch returnable/editable
    searchedMerchId: null,
  },
  getters: {
    // map of editOrderMerchList
    editOrderMerchMap(state) {
      return state.editOrderMerchList.reduce((obj, item) => {
        obj[item.item_type_id] = item;
        return obj;
      }, {});

    },
    merchListOnEditOrder(state, getters) {
      // equivalent of state.merchList when edit order, 
      // if the merch is in the edit order merch map, then update the info
      // else copy the merch from the merch list
      if (!(window.location.href.includes("editOrderSampleId")
        || window.location.href.includes("addOnSampleId"))
      ) {
        return [];
      }
      const list = [];
      state.merchList.forEach(item => {
        if (!getters.editOrderMerchMap[item.id]) {
          // If the item is not in editOrderMerchMap, add it directly
          list.push(item);
        } else {
          // If the item is in editOrderMerchMap, make a copy and update fields
          const editOrderItem = getters.editOrderMerchMap[item.id];
          const copyItem = { ...item };

          // Update fields
          copyItem.return_and_refund_info = editOrderItem.merchandise_refund_info;
          copyItem.applicable_promotions = null;
          copyItem.priceInEditOrder = editOrderItem.unit_price;
          copyItem.quantityInEditOrder = editOrderItem.quantity;
          copyItem.price = editOrderItem.original_price / editOrderItem.quantity;
          copyItem.orderedDate = state.editOrderDate;
          list.push(copyItem);
        }
      });
      return list;
    },
    rawMerchMap(state, getters) {
      // raw merch map without formatting
      // if edit order, use the merchlist of edit order
      // else use general merch list
      const merchList = window.location.href.includes("editOrderSampleId") || window.location.href.includes("addOnSampleId")
        ? getters.merchListOnEditOrder
        : state.merchList;
      return merchList.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {});
    },
    formattedMerchList(state, getters) {
      // if edit order, use the merchlist of edit order
      // else use general merch list
      const haveSearch = state.searchedMerchId;
      const merchList = window.location.href.includes("editOrderSampleId") || window.location.href.includes("addOnSampleId")
        ? getters.merchListOnEditOrder
        : state.merchList;
      return (haveSearch
        ? merchList.filter(obj => obj.id === state.searchedMerchId)
        : merchList
      ).map((obj, idx) => parseObjectFromApi(obj, idx));
    },
    merchMap(state, getters) {
      // id - item map for formattedMerchList,
      // used for targeting the item need to add/remove
      return getters.formattedMerchList.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {});
    },
    selectedMerchList(state, getters, rootState) {
      // merchandise only available in patient pay
      const paymentMethod = rootState.orderTest.order.paymentMethod;
      if (!window.location.href.includes("testpricecalculator") && (!paymentMethod || paymentMethod === "customerPay")) {
        return [];
      }
      return Object.entries(state.selectedMerchMap)
        .map(([id, details]) => ({ id, ...details }))
        .filter(item => item.quantity > 0) // Filter out items with quantity 0
        .sort((a, b) => a.id.localeCompare(b.id)); // Sort by id in ascending order
    },
    merchTotalPrice(state, getters) {
      let price = getters.selectedMerchList.reduce((acc, item) => {
        return acc + item.merch.currentPrice * item.quantity;
      }, 0);
      return Number(price.toFixed(2));
    },
    merchTotalPriceEditOrder(state, getters) {
      let price = getters.selectedMerchListEditOrder.reduce((acc, item) => {
        return acc + item.merch.currentPrice * item.quantity;
      }, 0);
      return Number(price.toFixed(2));
    },
  },
  mutations: {
    SET_MERCH_LIST(state, merchList) {
      state.merchList = merchList ? merchList : [];
    },
    ADD_ITEM_TO_SELECTED_MERCH_MAP(state, { id, merch }) {
      state.selectedMerchMap[id] = { merch, quantity: 1 };
    },
    ADD_QUANTITY_TO_SELECTED_MERCH_MAP(state, id) {
      if (state.selectedMerchMap[id]) {
        state.selectedMerchMap[id].quantity += 1;
      }
    },
    REMOVE_ITEM_FROM_SELECTED_MERCH_MAP(state, id) {
      delete state.selectedMerchMap[id];
    },
    DECREASE_QUANTITY_IN_SELECTED_MERCH_MAP(state, id) {
      state.selectedMerchMap[id].quantity -= 1;
    },
    REMOVE_ALL_QUANTITY_IN_EDIT_ORDER(state, id) {
      state.selectedMerchMap[id].quantity = 0;
    },
    CLEAR_ALL_SELECTED_MERCH(state) {
      state.selectedMerchMap = {};
    },
    SET_EDIT_ORDER_MERCH_LIST(state, list) {
      state.editOrderMerchList = list;
    },
    SET_EDIT_ORDER_DATE(state, str) {
      state.editOrderDate = str;
    },
    ADD_TO_SELECTED_MERCH_MAP_WITH_QUANTITY(state, params) {
      const { id, merch, quantity } = params;
      state.selectedMerchMap[id] = { merch, quantity };
    },
    SET_SEARCHED_MERCH_ID(state, id) {
      state.searchedMerchId = id;
    },
    DELETE_SEARCHED_MERCH_ID(state) {
      state.searchedMerchId = null;
    }
  },
  actions: {
    async setMerchandise({ commit, rootState }) {
      const userInfo = rootState.orderTest.user.userInfo;
      if (!userInfo) {
        return;
      }
      const { isClinic, customer_id, clinic_id } = userInfo;
      const account_type = isClinic ? "clinic" : "customer";

      try {
        const { data } = await getAllMerchandisesForOrder({
          account_type,
          customer_id,
          clinic_id,
        });
        commit("SET_MERCH_LIST", data);
      } catch (error) {
        console.error(error);
        commit("SET_MERCH_LIST", []);
      }

    },
    addToSelectedMerchMap({ state, getters, commit }, id) {
      const merch = getters.merchMap[id];
      if (merch) {
        if (state.selectedMerchMap[id]) {
          commit("ADD_QUANTITY_TO_SELECTED_MERCH_MAP", id);
        } else {
          commit("ADD_ITEM_TO_SELECTED_MERCH_MAP", { id, merch });
        }
      }
    },
    removeFromSelectedMerchMap({ state, commit }, id) {
      const inEditMode = window.location.href.includes("editOrderSampleId") || window.location.href.includes("addOnSampleId");
      if (state.selectedMerchMap[id]) {
        if (state.selectedMerchMap[id].quantity > 1 || inEditMode) {
          commit("DECREASE_QUANTITY_IN_SELECTED_MERCH_MAP", id);
        } else {
          commit("REMOVE_ITEM_FROM_SELECTED_MERCH_MAP", id);
        }
      }
    },
    removeAllQuantityInEditOrder({ state, commit }, id) {
      commit("REMOVE_ALL_QUANTITY_IN_EDIT_ORDER", id);
    },
    clearAllSelectedMerch({ commit }) {
      commit("CLEAR_ALL_SELECTED_MERCH");
    },
    setEditOrderMerchList({ commit }, list) {
      commit("SET_EDIT_ORDER_MERCH_LIST", list);
    },
    setEditOrderDate({ commit }, str) {
      commit("SET_EDIT_ORDER_DATE", str);
    },
    addToSelectedMerchMapWithQuantity({ commit }, params) {
      commit("ADD_TO_SELECTED_MERCH_MAP_WITH_QUANTITY", params);
    },
    setEditOrderSelectedMerchMap({ state, getters, dispatch }) {
      state.editOrderMerchList.forEach(item => {
        const id = item.item_type_id;
        const merch = getters.merchMap[id];
        const { orderedDate, returnDaysNum, quantityInEditOrder } = merch;

        const orderedDateObj = new Date(orderedDate);

        const returnDeadline = new Date(orderedDateObj);
        returnDeadline.setDate(returnDeadline.getDate() + returnDaysNum);
        const now = new Date();
        const changeable = returnDeadline > now;

        if (merch) {
          dispatch("addToSelectedMerchMapWithQuantity", { id, merch, quantity: quantityInEditOrder });
        }
      });
    },
    setSearchedMerchId({ commit }, id) {
      commit('SET_SEARCHED_MERCH_ID', id);
    },
    deleteSearchedMerchId({ commit }) {
      commit('DELETE_SEARCHED_MERCH_ID');
    }
  }
};

export default merchandise;